import Carousel from 'react-bootstrap/Carousel';
import imagen1 from '../../assets/img/landingimage/capacitaciononline.png';
import imagen2 from '../../assets/img/landingimage/mejorandovidas.png';
import imagen3 from '../../assets/img/landingimage/profesionales.png';

import './carousel.css'

function LandingCarousel() {
    const arrLandingCarousel = [
        imagen1,
        imagen2,
        imagen3
    ]
    return (
        <Carousel fade>
            {arrLandingCarousel.map((item, index) => (
                    <Carousel.Item  key={index} interval={1500}>
                        <img 
                        src={item} 
                        className="d-block w-100 carousel-image"  
                        alt={`Slide ${index}`}
                         />
                        <Carousel.Caption>
                            {/* <h3>Slide label {index}</h3>
                            <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                        </Carousel.Caption>
                    </Carousel.Item>
                ))}
        </Carousel>
    );
}

export default LandingCarousel;